import { alpha, PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { green, grey } from './colors';

export const action = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['action'] => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    return {
      hover: tokens['--semantic-bg-interactive-neutral-hover'],
      selected: tokens['--semantic-bg-interactive-neutral-active'],
      disabledBackground: tokens['--semantic-bg-interactive-neutral-disabled'],
      disabled: tokens['--semantic-text-disabled'],
      menuSelected: tokens['--semantic-bg-interactive-neutral-active'],
    };
  }

  const hover = alpha(grey[300], 0.2);
  const selected = alpha(grey[300], 0.35);

  return mode === 'light'
    ? {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.5),
        disabled: alpha(grey[500], 0.6),
        menuSelected: green[50],
      }
    : {
        hover,
        selected,
        disabledBackground: alpha(grey[300], 0.35),
        disabled: alpha(grey[300], 0.5),
        menuSelected: green[800],
      };
};
